module.exports = __webpack_public_path__ + "img/qu_ma.97fe1ef.jpg";